/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { BillingStateEnum } from './billingStateEnum';
import { BillingModeEnum } from './billingModeEnum';
import { BucketModeEnum } from './bucketModeEnum';


export interface BillingIntervalWithIdDef { 
    billing_mode?: BillingModeEnum;
    billing_state?: BillingStateEnum;
    /**
     * AWS Account number for usage files storage bucket
     */
    bucket_account?: string;
    bucket_mode?: BucketModeEnum;
    /**
     * Bucket Name of usage files storage
     */
    bucket_name?: string;
    /**
     * Timestamp in UTC when the interval was inserted in table
     */
    created_ts?: Date;
    /**
     * Interval end timestamp in UTC
     */
    end_ts?: Date;
    /**
     * Foreign Key from billing_entity table
     */
    entity_id?: number;
    /**
     * Foreign Key from event_history table
     */
    event_history_id?: number;
    /**
     * Primary Key
     */
    id?: number;
    /**
     * Interval start timestamp in UTC
     */
    start_ts?: Date;
    /**
     * Timestamp in UTC when the interval was updated in table
     */
    updated_ts?: Date;
}
export namespace BillingIntervalWithIdDef {
}


